import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-shared-dialog',
  templateUrl: './shared-dialog.component.html',
  styleUrl: './shared-dialog.component.scss',
  standalone: false
})
export class SharedDialogComponent {
  public data: { title: string; message: string; messageHtml?: string; buttonText: string; cancelButtonText?: string } =
    inject(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<SharedDialogComponent>);

  constructor() {}

  onClose(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
